import { windowHeartbeatPrefix } from "./window-heartbeat-service";
import { getFlightDetails } from "./window-communication-bridge-flighting";
import { HeuristicallyGeneratedLocalStorageKeyMap } from "../../ServiceDesk/sdServices/heuristically-generated-local-storage-key-map";
import { getKeys } from "../../ServiceDesk/sdServices/local-storage-wrapper-service";

let instance: HeartbeatStorage;

export class HeartbeatStorage {
  private isWrapperEnabled = false;
  private wrapperEnabledPromise: Promise<any>;
  private heuristicMap: HeuristicallyGeneratedLocalStorageKeyMap;

  private constructor() {
    this.wrapperEnabledPromise = new Promise<any>((resolve, reject) => {
      getFlightDetails().then((flightDetails) => {
        this.isWrapperEnabled = flightDetails.useLocalStorageWrapper;
        if (this.isWrapperEnabled) {
          this.heuristicMap = new HeuristicallyGeneratedLocalStorageKeyMap(windowHeartbeatPrefix, 100);
          resolve();
        } else {
          reject("flight off");
        }
      });
    }).catch(() => {});
  }

  public static getInstance() {
    if (!instance) {
      instance = new HeartbeatStorage();
    }
    return instance;
  }

  public getItem(providedKey: string): string {
    return window.localStorage.getItem(providedKey);
  }

  public removeItem(providedKey: string) {
    return window.localStorage.removeItem(providedKey);
  }

  public setItem(providedKey: string, providedValue: string, windowId: string) {
    if (this.isWrapperEnabled) {
      let containsKey = false;
      this.heuristicMap.entries().forEach((value, key) => {
        if (providedKey == key) {
          containsKey = true;
        }
      });
      if (!containsKey) {
        this.trackStorageItem(providedKey, windowId);
      }
    }
    localStorage.setItem(providedKey, providedValue);
  }

  public getHeartbeatEntries() {
    if (this.isWrapperEnabled) {
      return this.heuristicMap.entries();
    }
    let filteredMap = new Map<string, string>();
    getKeys(window.localStorage, false).forEach((key) => {
      if (key.startsWith(windowHeartbeatPrefix)) {
        if (key) {
          let value = window.localStorage.getItem(key);
          if (value) {
            filteredMap.set(key, value);
          }
        }
      }
    });
    return filteredMap;
  }

  public trackStorageItem(key: string, windowId: string) {
    this.wrapperEnabledPromise
      .then(() => {
        this.heuristicMap.safeTrackKey(key, windowId);
      })
      .catch((e) => {});
  }
}
